import AOS from 'aos';

//== initialise AOS - disabled on mobile and when prefers-reduced-motion is set
//== double rAF ensures the browser paints the initial hidden/offset state once
//== before AOS adds aos-animate, so above-the-fold elements have a state to transition from
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    AOS.init({
      once: true,
      offset: 20,
      duration: 800,
      easing: 'ease-out-cubic',
      disable: () => {
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const isMobile = window.matchMedia('(max-width: 767px)').matches;
        return prefersReducedMotion || isMobile;
      },
    });
  });
});

//== recalculate after everything has loaded
window.addEventListener('load', () => {
  refreshAOS();
});

//== manual refresh hook for callers that mutate the dom after init
export const refreshAOS = () => {
  AOS.refresh();
};
